import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import Button, { BUTTON_WIDTH, BUTTON_SIZE } from "@gc-npm/components.button";
import CustomLink from "@gc-npm/components.custom-link";
import Glyph from "@gc-npm/components.icon-glyph";
import TextInfo, {
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_ALIGN,
  TEXT_FONT_WEIGHT,
  TEXT_DISPLAY,
} from "@gc-npm/components.text";

import sendGaEvent from "@gc-npm/utils.metrics.send-ga-event";
import { SCREEN_TYPES } from "@/utils/constants";
import { COLORS } from "@gc-npm/utils.enums.colors";

const COMPONENT_NAME = "ChangeFusionToMiMovistarModal";

const ChangeFusionToMiMovistarModal = ({ screenType, title, p1, p2a, p2b, p3, buttonLabel }) => {
  const dispatch = useDispatch();

  const taggingInfo = {
    componentName: COMPONENT_NAME,
    componentProduct: "",
    componentContent: title || "",
    componentVariation: "",
  };

  useEffect(() => {
    sendGaEvent({
      ...taggingInfo,
      eventType: "print-success",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCloseModal = () => {
    dispatch(
      modalActions.addModal({
        id: "",
      })
    );
  };

  const onAccept = () => onCloseModal();

  return (
    <div className="ChangeFusionToMiMovistarModal">
      <div className="modal__header">
        <div className="modal__title">
          <TextInfo
            text={title}
            kind={TEXT_KIND.PARAGRAPH}
            color={TEXT_COLOR.GREY6}
            size={TEXT_SIZE.T4}
            align={TEXT_ALIGN.LEFT}
            fontType={TEXT_FONT_WEIGHT.BOLD}
          />
        </div>

        <div className="modal__close">
          <CustomLink
            ariaLabel="Cerrar"
            taggingInfo={{ ...taggingInfo, componentContent: "Cerrar" }}
            onClick={onCloseModal}
          >
            <Glyph
              id="cerrar"
              height={20}
              width={20}
              color={TEXT_COLOR.MOVISTAR_BLUE}
            />
          </CustomLink>
        </div>
      </div>

      <div className="modal__body">
        <TextInfo
          text={p1}
          kind={TEXT_KIND.PARAGRAPH}
          color={TEXT_COLOR.GREY6}
          size={TEXT_SIZE.BODY1}
          align={TEXT_ALIGN.LEFT}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />

        <div className="modal__p2">
          <TextInfo
            text={p2a}
            kind={TEXT_KIND.PARAGRAPH}
            display={TEXT_DISPLAY.INLINE}
            color={TEXT_COLOR.GREY6}
            size={TEXT_SIZE.BODY1}
            align={TEXT_ALIGN.LEFT}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
          <TextInfo
            text={p2b}
            kind={TEXT_KIND.PARAGRAPH}
            display={TEXT_DISPLAY.INLINE}
            color={TEXT_COLOR.GREY6}
            size={TEXT_SIZE.BODY1}
            align={TEXT_ALIGN.LEFT}
            fontType={TEXT_FONT_WEIGHT.BOLD}
          />
        </div>

        <TextInfo
          text={p3}
          kind={TEXT_KIND.PARAGRAPH}
          color={TEXT_COLOR.GREY6}
          size={TEXT_SIZE.BODY1}
          align={TEXT_ALIGN.LEFT}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />
      </div>

      <div className="modal__footer">
        <Button
          label={buttonLabel}
          onClick={onAccept}
          taggingInfo={{
            ...taggingInfo,
            componentContent: buttonLabel,
            eventType: "click",
          }}
          width={
            screenType === SCREEN_TYPES.MOBILE
              ? BUTTON_WIDTH.FULL
              : BUTTON_WIDTH.SMALL
          }
          forceExternal
        />
      </div>

      <style jsx>{`
        .ChangeFusionToMiMovistarModal {
          background-color: ${COLORS.white};
          padding: 2rem;
          border-radius: 20px;
          width: 720px;
          max-width: calc(100vw - 48px);
          display: flex;
          flex-direction: column;
          gap: 1.25rem;
          max-height: 90vh;
          overflow: auto;
        }

        .modal__header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 1rem;
        }

        .modal__close {
          display: flex;
          justify-content: flex-end;
        }

        .modal__body {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .modal__p2 {
          display: inline;
        }

        .modal__footer {
          padding-top: 0.25rem;
        }

        @media (max-width: 768px) {
          .ChangeFusionToMiMovistarModal {
            padding: 1rem;
            border-radius: 20px 20px 0 0;
            width: 100vw;
            max-width: 100vw;
            max-height: 80dvh;
          }
        }
      `}</style>
    </div>
  );
};

export default ChangeFusionToMiMovistarModal;